import React from 'react';
import { Link,Redirect } from "react-router-dom";

import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	CustomInput,
	Form,
	Row,
	Col,
	Label,

} from 'reactstrap';
import {getData} from '../../services/index';
import { message,Button,Input  } from 'antd';

//import QrReader from 'react-qr-reader';
import { QrReader } from 'zxing-qr-reader';

class Login2 extends React.Component {
    static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			tabs: 'login',
			result: 'No result'
		};	
	}
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({
							user_id: user_id,school_id:school_id
						});
	    } 	
		setTimeout(() => {
			this.openScan();
		}, 500);
		window.checkPermission();
		setInterval(window.checkPermission(), 500);
		setInterval(this.openScan(), 500);
	}
	
	
	openScan(){
		const canvas = document.getElementById('canvas_');
		const context = canvas.getContext('2d');
		this.qr_reader = new QrReader(context);
		this.qr_reader.scan();
		
		this.qr_reader.on('found', (result) => {
			console.log(result);
			this.qr_reader.stop();
			this.handleScan(result.text);
		});
	}
	
	componentWillUnmount() {
		this.qr_reader.stop();
	}
	
	getProduct=(machine_code,machine_location)=>{
		this.props.history.push({
		   pathname: '/home-otg',
		   state: { machine_code: machine_code,machine_location:machine_location }
		});
	}
	
	handleScan = data => {
		  if(data) {
			 var app = {user_id : data,school_id:this.state.school_id,staff_id:this.state.user_id}
				getData('erp/scan_qrcode',app).then((result) => { 
					let responseJson = result;
					var res_message = result['message'];
					if(responseJson){
						if(result['status'] == 200){
							message.config({ top: 150});
							message.success(res_message,2);
						}else{
							message.config({ top: 150});
							message.success(res_message,2);
						}
						window.location.href = '/';
					}
				});  
		  }
	  }
	  
	  handleError = err => {
		  console.error(err)
	  }

	render() {
		return (
			<>
			<div class="mobile-view">
				<div class="col s12 m12 ex-padd">
					<div id="breadcrumbs-wrapper" class="bg-off">
					   <div class="">
						  <div class="row no-margin">
						  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">

							  <div class="col s12 m6 l6 pb-15 mt-5">
								<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">QR Check In</span></h5>
							 </div>
							 </div>
						  </div>
					   </div>
					</div>
				</div>
			</div>
				<div class="login-wrapper d-flex align-items-center justify-content-center text-center">
				  <div class="container">
					 <div class="row justify-content-center">
					  <div class="col s12 m12">
						  <div class="scan-box center">
						   <canvas id="canvas_" width={300} height={300}></canvas>
						   <div class="text-gold">Scan The QR Code</div>
						   <Link to={`${process.env.PUBLIC_URL}/`} className="btn center btn-warning btn-lg w-100 btn-login btn-back" >
								BACK
						   </Link>
						   <br/><br/>
						  <button onClick={window.checkPermission}>click</button>
							 
						</div>
					  </div>
					</div>
				  </div>
				</div>
			</>
		)
	}
}

export default Login2;